import { useTranslation } from "react-i18next";
import styles from "./ActionModal.module.css";
import Button from "../Button/Button";

export default function ActionModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "default",
  isLoading = false,
}) {
  const { t } = useTranslation("common");
  if (!isOpen) return null;

  const handleConfirm = async () => onConfirm?.();

  const handleCancel = () => onClose?.();

  const handleBackdropClick = (e) => {
    if (
      e.target === e.currentTarget &&
      type !== "success" &&
      type !== "failure"
    ) {
      handleCancel();
    }
  };

  const confirmButtonClassName = [
    styles.confirmButton,
    type === "danger" || type === "failure"
      ? styles.confirmDanger
      : type === "success"
      ? styles.confirmSuccess
      : styles.confirmDefault,
    type !== "success" && type !== "failure" ? styles.confirmWithCancel : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>{title}</h3>
          {type !== "success" && type !== "failure" && (
            <button
              className={styles.closeButton}
              onClick={handleCancel}
              disabled={isLoading}
            >
              ✕
            </button>
          )}
        </div>

        <div className={styles.modalBody}>
          <div className={styles.iconContainer}>
            {type === "danger" && <span className={styles.dangerIcon}>⚠️</span>}
            {type === "warning" && (
              <span className={styles.warningIcon}>⚠️</span>
            )}
            {type === "success" && (
              <span className={styles.successIcon}>✅</span>
            )}
            {type === "failure" && (
              <span className={styles.failureIcon}>❌</span>
            )}
            {type === "default" && (
              <span className={styles.defaultIcon}>❓</span>
            )}
          </div>
          <p className={styles.modalMessage}>{message}</p>
        </div>

        <div className={styles.modalFooter}>
          {type !== "success" && type !== "failure" && (
            <Button
              onClick={handleCancel}
              variant="outlined"
              disabled={isLoading}
            >
              {cancelText}
            </Button>
          )}
          <Button
            onClick={handleConfirm}
            className={confirmButtonClassName}
            disabled={isLoading}
          >
            {isLoading ? t("loading") : confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}
